export default __webpack_public_path__ + "static/media/markofset.6e2911d0.png";